import styled, { css } from 'styled-components';

import zIndex from '@/styles/zIndex';

import { Flex, VFlex } from '../base';
import Input from '../Inputs/Input';
import type { OptionProps } from './types';

const Style = styled.div`
  position: relative;
  cursor: default;
`;

const SelectBox = styled(Flex)<{ isEditor: boolean }>`
  cursor: ${({ isEditor }) => (isEditor ? 'pointer' : 'auto')};
`;

type OptionListProps = {
  width?: string;
  reverse?: boolean;
};

export const OptionList = styled(VFlex)<OptionListProps>`
  overflow: auto;
  box-sizing: border-box;
  min-width: 200px;
  max-width: 600px;
  max-height: 400px;
  padding: 4px;
  gap: 2px;
  width: ${({ width }) => (width ? width : '180px')};
  z-index: ${zIndex.dropdown};
  ${({ reverse }) =>
    reverse === true &&
    css`
      display: flex;
      flex-direction: column-reverse;
    `}
`;

export const OptionListTitle = styled(Flex)`
  align-items: center;
  width: 100%;
`;

export const Option = styled(Flex)<OptionProps>`
  align-items: center;
  width: 100%;
  cursor: pointer;
  padding: 4px 8px;
  transition: all 0.2s;
  border-radius: 6px;
  min-height: 28px;
  font-size: 12px;

  &:hover {
    background: ${(props) => props.theme.colors.ND04};
  }

  ${({ focused }) =>
    focused &&
    css`
      background: ${(props) => props.theme.colors.ND08};
      &:hover {
        background: ${(props) => props.theme.colors.ND08};
      }
    `}

  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 0.5;
      cursor: not-allowed;
    `}
`;

const SelectedItemStyle = styled(Flex)<{ isEditor: boolean }>`
  height: 32px;
  padding: 0 8px 0 11px;
  width: 100%;
  min-width: 120px;
  border-radius: 6px;
  font-size: 12px;
  line-height: 30px;
  font-weight: 400;
  border: 1px solid ${(props) => props.theme.colors.gray400};
  cursor: ${({ isEditor }) => (isEditor ? 'pointer' : 'auto')};
  color: ${(props) => props.theme.colors.gray700};
  transition: all 0.3s;
  &:hover {
    border: 1px solid ${(props) => props.theme.colors.primary100};
  }
`;

const NewItem = styled(Flex)<OptionProps>`
  padding: 4px 8px;
  cursor: pointer;
  border-radius: 2px;
  ${({ focused }) =>
    focused &&
    css`
      background-color: ${(props) => props.theme.colors.ND06};
      &:hover {
        background-color: ${(props) => props.theme.colors.ND08};
      }
    `}
`;

const DropdownStyledInput = styled(Input)`
  height: 32px;
  border-radius: 0;
  border: none;
  &:focus {
    border: none;
  }
`;

const SelectDropdownStyle = {
  DropdownStyledInput,
  SelectedItemStyle,
  NewItem,
  Style,
  SelectBox,
  OptionList,
  OptionListTitle,
  Option,
};

export default SelectDropdownStyle;
